/**
 * External dependencies
 */
import { omit } from 'lodash';

/**
 * Internal dependencies
 */
import { CURRENT_USER_RECEIVE, CURRENT_SUBSCRIPTION_RECEIVE } from 'state/action-types';

const initialState = { id: null, subscription: null };

const currentUser = (state = initialState, action) => {
	switch (action.type) {
		case CURRENT_USER_RECEIVE:
			return omit(
				{
					...state,
					id: action.user.username,
					...action.user,
				},
				['storage', 'pool', 'client'], // temp
			);
		case CURRENT_SUBSCRIPTION_RECEIVE:
			return {
				...state,
				subscription: action.subscription,
			};
		default:
			return state;
	}
};

export default currentUser;
